import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class CreateLabel extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Create Label </h2>

                <br/>
               

                <h6> How To Create a Label: </h6>
                
                <p className='text-primary'>1) Click the 'Create Shipping Label' button on any lost item.  The shipping wizard will launch.  </p>
                <br/><br/><br/>
                <div className="text-center">
                <img className='text-center' src='./images/createshipping.png'  alt=''/> 
              
                   
                </div>

                
              <hr/>


                 <br/> <br/> 
               <h6> Step 1</h6>
               <p className='text-primary'>
                    Type the first name the last name and the email address for the guest that we'll be receiving the shipping label request. Some of these fields will automatically be filled in if the lost item already has a claim and this was initiated from the claim screen. 
                    <br/>
                    If this is an international shipment check international shipping at the bottom prior to clicking next. First name last name and email address are the only required fields in this step.
                    </p>
                <br/>
               <div className="text-center">
                    <img className='text-center' style={{maxWidth:600, width:"100%",maxHeight:600, height:"100%"}} src='./images/step1.png' alt=''/> 
                </div>
<br/><hr/><br/>
              
              <h6> Step 2</h6>
             
               <p className='text-primary'>
          
This step is used to define the size of the box with the container that will be used to ship the item back to the guest.
<br/><br/>
<h6> Ship Date </h6>
The <b>ship date</b> will be the date when the carrier will arrive to pick up the item. It is important to note that the ship date factors into the cost of the shipping options.
<br/><br/> 
<h6> Parcel Size </h6>
The parcel size drop down box has a list of all the different carrier configurations available. Pick the appropriate size box and the fields Length, Width and Height (L X W X H) will auto-fill with the 
selection dimensions. NOTE: Select "Own Packaging" if your not using any carrier-specific boxes.  
<br/><br/> 
<h6> Hotels Supporting Multiple Carriers </h6> 
 If you're hotel is set up to support multiple carrier options for your gas selecting any of these items will not limit or filter out that carrier. 
 For example if your hotel supports multiple carriers for your guest to choose from, choosing FedEx would not filter route UPS, USPS or DHL from their selections. 
 They would only be used to auto fill the length the width and height dimensions of the box used for shipping.
<br/><br/>
 Once the screens fields are all filled click next.
                <br/>
               <div className="text-center">
                    <img className='text-center' style={{maxWidth:600, width:"100%",maxHeight:600, height:"100%"}} src='./images/step2.png' alt=''/> 
                </div>

                 </p>
                


                    <hr/> <br/> <br/> 
                    <h6> Step 3: </h6>
             
             <p className='text-primary'>
        


            <b>International Customs Declarations</b>
            <br/>
            For international shipments, this screen's fields are all required. <br/>
            The type of content, the signing person, the quantity the value, and the currency of the item being shipped are all required and  important to have listed on the customs declaration.  
            The custom declaration will be printed on the label. 
            <br/>
            Select the country of origin this will also be required. Once completed click the button to verify shipping information.
                            <br/>
                            <div className="text-center">
                                <img className='text-center' style={{maxWidth:600, width:"100%",maxHeight:600, height:"100%"}} src='./images/Step3.png' alt=''/> 
                            </div>

                        </p>
                        <hr/> <br/> <br/> 
            <h6> Step 4: </h6>
             
             <p className='text-primary'>
        


            <b>Verify</b>
            <br/>
            Verify the shipping information and email address.  Click "Send Shipping Request to Guest" to contine.  This screen will verify the information and send the guest the email.  
            <br/> The screen will show a green success screen next to indicate that the settings and email have been sent successfully.   

                            <br/>
                            <div className="text-center">
                                <img className='text-center' style={{maxWidth:600, width:"100%",maxHeight:600, height:"100%"}} src='./images/Step4.png' alt=''/> 
                            </div>

                        </p>

                     <h6> Step 5: Completed Screen </h6>
             
             <p className='text-primary'>   The screen will show a green success screen next to indicate that the settings and email have been sent successfully. </p>
             
                   
    </div>
    )
       


    }

}
export default withRouter(CreateLabel);
